import React from "react";

/**
 * Persistent top bar for AppShell. Contains: universal search, role context,
 * Quick-Create button, and popover icons for approvals inbox, messages,
 * alerts, help, profile, portal switcher.
 *
 * R1b-α Fix #6 addition: optional `leading` slot (left of the search input) for the Back button.
 * R1b-α Step 1 addition:
 *   - `search` prop — element that REPLACES the default input if provided
 *     (used by AdminAppShell to inject the wired <GlobalSearch />).
 *   - `trailing` prop — element rendered BEFORE iconLaunchers (used for
 *     tenant chip + identity block).
 */
export function TopBar({
  roleContext,
  searchPlaceholder = "Search…",
  iconLaunchers = [],
  quickCreate,
  leading,
  search,
  trailing,
}) {
  return (
    <div className="ds-shell-top">
      {leading}
      {search !== null && (
        <div className="ds-shell-search">
          {search ? search : (
            <input aria-label="Universal search" placeholder={searchPlaceholder} />
          )}
        </div>
      )}
      {roleContext && <div className="ds-shell-role">{roleContext}</div>}
      {trailing}
      {quickCreate}
      {iconLaunchers.map((l) => (
        <button
          key={l.key}
          className="ds-shell-icon"
          aria-label={l.ariaLabel}
          onClick={l.onClick}
          type="button"
          data-testid={l.testId}
          title={l.title}
          style={{ position: "relative", minWidth: 44, minHeight: 44 }}
        >
          {l.icon}
          {l.count > 0 && (
            <span className="count" data-testid={l.badgeTestId}>{l.count}</span>
          )}
        </button>
      ))}
    </div>
  );
}
